import {Login} from './login';

export default {
    component: Login
};
